module.exports = __webpack_public_path__ + "img/H4.b4f600a5.png";